import { useState } from "react"
import "./billingDetails.css"

export function BillingDetails() {
    const [saveCheckbox, setSaveCheckbox] = useState(false)

    return (
        <div className="billing-details">
            
            <div>First Name<span className="red-asteriks">*</span></div>
            <input type="text" className="custom-input" />

            <div>Company Name</div>
            <input type="text" className="custom-input" />

            <div>Street Address<span className="red-asteriks">*</span></div>
            <input type="text" className="custom-input" />

            <div>Apartment, floor, etc. (Optional)</div>
            <input type="text" className="custom-input" />

            <div>Town/City<span className="red-asteriks">*</span></div>
            <input type="text" className="custom-input" />

            <div>Phone Number<span className="red-asteriks">*</span></div>
            <input type="text" className="custom-input" />

            <div>Email Address<span className="red-asteriks">*</span></div>
            <input type="text" className="custom-input" />

            <input
                type="checkbox"
                id="save-info"
                name="save-info"
                defaultChecked={saveCheckbox}
                onClick={(e) => setSaveCheckbox(e.target.checked)}
                className="d-none"
            />
            <label htmlFor="save-info">
                <div className="d-flex align-items-center gap-3">

                    <div className={`custom-checkbox rounded-1 ${saveCheckbox ? "is-checked" : ""}`}>
                    </div>

                    <div className="text-black">
                        Save this information for faster check-out next time
                    </div>

                </div>
            </label>

        </div>
    )
}